<template>
    <div :class="[{ 'is-survey': isSurvey }, {'is-not-survey': !isSurvey}]">
        <div class="text-response">
            <div class="response"
                v-for="(r, i) in response"
                :key="i">
                <div :class="['date', {'no-answer-date': !r || !r[0]}]" v-if="response.length > 1">
                    {{ questionnaireDate(i) }}
                </div>
                <div class="answer-wrapper">
                    <span v-if="r != null && r[0]" class="sign-and-date answer">
                        <template v-if="r[0].image_url">
                            Signed
                            {{ r[0].name ? ` by ${r[0].name}` : '' }}
                            {{ r[0].role ? ` , ${r[0].role}` : '' }}
                            -
                            {{formatDateTime(r[0].meta.device_time)}}
                            <div class="oval"></div>
                            <div class="new-tab-title">Legal Document</div>
                            <el-button @click="openLegalDoc(i)" class="open-icon-button">
                                <OpenNewIcon class="open-icon"></OpenNewIcon>
                            </el-button>
                        </template>
                        <template v-if="r[0].acknowledged">
                            Acknowledged
                            {{ r[0].name ? ` by ${r[0].name}` : '' }}
                            {{ r[0].role ? ` , ${r[0].role}` : '' }}
                            -
                            {{formatDateTime(r[0].meta.device_time)}}
                            <div class="oval"></div>
                            <div class="new-tab-title">Legal Document</div>
                            <el-button @click="openLegalDoc(i)" class="open-icon-button">
                                <OpenNewIcon class="open-icon"></OpenNewIcon>
                            </el-button>
                        </template>
                    </span>
                    <div v-else class="no-answer">
                        <span>Not Answered</span>
                    </div>
                </div>
                <el-popover
                    placement="left"
                    width="400"
                    trigger="click"
                    :key="renderKey"
                    v-if="isSurvey && getUserType === 'observer'"
                    class="flag-modal">
                    <button :disabled="comment.length != 0" :class="[showFlagDialog[i] ? 'flag-unresolved-button' : 'flag-button']" @click="addFlag(i)" slot="reference">
                        <img :src="require(showFlagDialog[i] ? './icon/flag-unresolved.png' : './icon/flag.png')" class="flag-image"> Flag
                        <span v-if="flagSavedText[i]" class="flag-saved-text">Flagged Successfully</span>
                    </button>
                    <div class="header">
                        Add Comment
                        <i class="el-icon-close" @click="closeModal(i)"></i>
                    </div>
                    <div class="add-comment">
                        <el-input
                            type="textarea"
                            size="small"
                            :rows="6"
                            placeholder="Start typing..."
                            :maxlength="150"
                            v-model="comment">
                        </el-input>
                        <span class="char-left">
                            {{ 150 - comment.length }} characters left
                        </span>
                    </div>
                    <div class="dialog-footer">
                        <LoadingButton type="primary" 
                            @click="markFlagged(i)" style="width:105px; float: right;"
                            :disabled="comment.length === 0"
                            :loading="flagLoading">
                            Done
                        </LoadingButton>
                        <el-button type="text" @click="closeModal(i)" class="cancel-button">Cancel</el-button>
                    </div>
                </el-popover>
            </div>
            <el-dialog
                title="Legal Document"
                :visible.sync="legalDocVisible"
                width="50%"
                :append-to-body="true"
                :close-on-click-modal="false"
                :before-close="handleClose">
                <div v-if="response[showIndex] && Array.isArray(response[showIndex]) && response[showIndex][0]">
                    <span v-if="response[showIndex][0].text"
                        class="attachments-text"
                        v-html="response[showIndex][0].text"></span>
                    <span v-else
                        class="attachments-text" v-html="question.attachments[0].text"></span>
                    <div v-if="response[showIndex][0].image_url">
                        <img :src="response[showIndex][0].image_url" class="signature-img">
                        <div class="signature-desc">
                            <p>{{ isSurvey ? getRequestName(showIndex) : patient.name}}</p>
                            <p>Signed
                                {{ response[showIndex][0].name ? ` by ${response[showIndex][0].name}` : '' }}
                                {{ response[showIndex][0].role ? ` , ${response[showIndex][0].role}` : '' }}
                                - {{fomatDateTimeFull(response[showIndex][0].meta.device_time)}}</p>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="legalDocVisible = false">Close</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import QuestionResponse from '.'
import { mapActions, mapGetters } from 'vuex'
import LoadingButton from '@/module/component/LoadingButton.vue'
import formatDateTime from '@/module/util/format-date-time'
import fomatDateTimeFull from '@/module/util/fomat-date-time-full'
import Icons from './icon'

export default {
    extends: QuestionResponse,

    data() {
        return {
            legalDocVisible: false,
            showIndex: null,
            comment: '',
			renderKey: 0,
			flagLoading: false,
			flagSavedText: this.response.map(_ => false),
			showFlagDialog: this.response.map(_ => false)
        }
    },

    methods: {
        formatDateTime,
        fomatDateTimeFull,
        ...mapActions('outcome', ['addFlagging', 'resolveFlagging']),
		addFlag(index) {
			if (this.comment.length)
				return
			this.showFlagDialog[index] = true
		},
		getUploader(uploaderId) {
            if(this.getUser && this.getUser.id === uploaderId)
                return this.getUser.name
            return null
        },
		/**
		 *  Flag object schema to send while marking/resolving flag
		 * 	{
		 * 		id: uuidv4(),
				problem_id: 'string', // event.problem id sent only during resolving
				question_id: this.question.id,
				comment: this.comment,
				// comment_resolution: 'string', //comment after marking resolved
				type: 'problem', // problem or resolution
				auth: this.getUserId
			}
		 */
		markFlagged(index) {
			this.comment = this.comment.trim()
			if (this.comment.length === 0)
				return
			this.flagLoading = true
			this.addFlagging({
				id: this.questionnaire[index].id,
				question_id: this.question.id,
				comment: this.comment,
				type: 'problem',
				auth: this.getUserId,
				patientId: this.patient.id
			})
			.then((response) => {
				this.flagLoading = false
				this.flagSavedText[index] = true
				this.closeModal(index)
				setTimeout(() => {
					this.flagSavedText[index] = false
					this.renderKey += 1
				}, 3000)
				response.problem_id = this.questionnaire[index].id
				response.modified_name = this.getUploader(response.modified_by)
				this.$emit('addFlagObj', response)
			})
		},
		closeModal(index) {
			this.showFlagDialog[index] = false
			this.comment = ''
			this.renderKey += 1
		},
        handleClose() {
            this.legalDocVisible = false
        },
        /**
         * Open legal attached doc or default doc dialog depending 
         * answer
         * @param {Number} index
         */
        openLegalDoc(index) {
            this.legalDocVisible = true
            this.showIndex = index
        },
        /**
         * Get name of the person who requested survey by showIndex
         * @param {Number} showIndex
         */
        getRequestName(showIndex) {
            if(this.questionnaire[showIndex] && this.questionnaire[showIndex].requested_by_name)
                return this.questionnaire[showIndex].requested_by_name
            return ''
        }
    },
    computed: {
		...mapGetters(['getUserType']),
		...mapGetters('user', ['getUser']),
		...mapGetters('auth', ['getUserId']),
		...mapGetters('provider', [ 'allPatientsChosen', 'getProviderNameById'])
	},

    components: {
        ...Icons,
        LoadingButton
    }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
.text-response {
	min-height: 30px;
}
.response.with-date {
	padding-left: 80px;
}
.empty {
	opacity: 0.4;
}
.open-icon {
    vertical-align: middle;
    margin-left: 8px;
    cursor: pointer;
}
.open-icon-button.el-button {
    border: none;
    padding: 0;
}
.open-icon-button.el-button:hover {
    background-color: transparent;
}
.signature-img {
    width: 120px;
    height: 60px;
    border: solid 1px #cccccc;
    background-color: #ffffff;
    margin-top: 20px;
    margin-left: 4px;
}
.signature-desc {
    display: inline-block;
    margin-left: 12px;
    color: #333333;
    font-size: 12px;
    font-weight: 600;
    position: relative;
    top: -4px;
}
.not-answered {
    font-size: 13px;
    font-weight: 500;
    color: #da4e4e;
    padding: 3px 5px;
    background-color: #fff2f2;
    box-shadow: 0 0 4px 0 rgba(131, 62, 147, 0.15);
}
.attachments-text {
    display: block;
    padding-left: 4px;
    padding-right: 4px;
    word-break: break-word;
    line-height: 1.33;
}
</style>
